import { render } from "./PillButton.vue?vue&type=template&id=7c26d538"
import script from "./PillButton.vue?vue&type=script&lang=js"
export * from "./PillButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/PillButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c26d538"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c26d538', __exports__)) {
    api.reload('7c26d538', __exports__)
  }
  
  module.hot.accept("./PillButton.vue?vue&type=template&id=7c26d538", () => {
    api.rerender('7c26d538', render)
  })

}


export default __exports__